// src/components/Formulario.jsx
import React, { useMemo, useState } from "react";
import axios from "axios";
import Whats from "./Whats";
import CircularProgress from "@mui/material/CircularProgress";
import "../styles/Formulario.scss";

const Formulario = () => {
  const phoneContact = 5213345851702;

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const [formStatus, setFormStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const isFormValid = useMemo(() => {
    const n = name.trim().length >= 2;
    const p = phone.trim().length >= 8; // mínimo básico
    const e = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    return n && p && e;
  }, [name, phone, email]);

  const handlePhoneChange = (e) => {
    // solo dígitos, sin perder la lógica (sigue siendo string controlado)
    const v = e.target.value.replace(/[^\d]/g, "");
    setPhone(v);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setFormStatus("");

    if (!isFormValid) {
      setFormStatus("Por favor completa nombre, teléfono y correo correctamente.");
      return;
    }

    const formData = { name, phone, email };

    setIsLoading(true);
    try {
      const response = await axios.post(
        "https://pixbaebanquetes.com/formulario/formulario.php",
        formData,
        { headers: { "Content-Type": "application/json" } }
      );

      console.log(response?.data);
      setFormStatus("✅ ¡Listo! Recibimos tus datos. En breve te contactamos.");
      setName("");
      setPhone("");
      setEmail("");
    } catch (error) {
      console.error(error);
      setFormStatus("❌ Ocurrió un error al enviar el formulario. Intenta nuevamente.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="formSection" id="formulario">
      <div className="container formWrap">
        <div className="formCard">
          <div className="formHeader">
            <h2 className="formTitle">Cotiza tu evento</h2>
            <p className="formSubtitle">
              Déjanos tus datos y te enviamos opciones de banquete para tu fecha y número de personas.
            </p>
          </div>

          <form className="formBody" onSubmit={handleSubmit}>
            <div className="gridInputs">
              <div className="field">
                <label htmlFor="nombre">Nombre</label>
                <input
                  type="text"
                  id="nombre"
                  name="nombre"
                  className="inputCustom"
                  placeholder="Ej. Carlos Ramírez"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  autoComplete="name"
                />
              </div>

              <div className="field">
                <label htmlFor="telefono">Teléfono</label>
                <input
                  type="tel"
                  id="telefono"
                  name="telefono"
                  className="inputCustom"
                  placeholder="Ej. 3312345678"
                  value={phone}
                  onChange={handlePhoneChange}
                  autoComplete="tel"
                  inputMode="numeric"
                />
              </div>

              <div className="field fieldFull">
                <label htmlFor="email">Correo</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="inputCustom"
                  placeholder="Ej. correo@dominio.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="email"
                />
              </div>
            </div>

            <p className="textTerms">
              Al enviar tus datos aceptas nuestras <b>Políticas de Privacidad</b>.
            </p>

            <div className="actions">
              <button className="btnPrimary" type="submit" disabled={isLoading}>
                {isLoading ? "Enviando..." : "Enviar datos"}
              </button>

              <div className="loadingBox" aria-live="polite">
                {isLoading && <CircularProgress sx={{ color: "#ff7a00" }} size={26} />}
              </div>

              <div className="dividerRow">
                <span className="dividerLine" />
                <span className="dividerText">o</span>
                <span className="dividerLine" />
              </div>

              <div className="altContact">
                <span className="altText">Contáctanos directo por WhatsApp</span>
                <Whats
                  classStyle="btnWhats"
                  message="Hola, quiero más información acerca de sus banquetes."
                  phoneNumber={phoneContact}
                  text="WhatsApp"
                />
              </div>
            </div>

            {formStatus && <div className="formStatus">{formStatus}</div>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Formulario;
